import {
    Box,
    Button,
    Drawer,
    DrawerBody,
    DrawerContent,
    DrawerHeader,
    DrawerOverlay,
    Flex,
    Text,
} from '@chakra-ui/react';
import { BsChevronLeft } from 'react-icons/bs';
import { getDeviceType } from '../../service/util';
import { RadioFilter } from '../RadioFilter';

interface DrawerProps {
    filterAll: string;
    onClose: () => void;
    isOpen: boolean;
    resetFilters: () => void;
    applyFilters: () => void;
    sections: {
        name: string;
        /**
         * not including the default option
         */
        otherOptions: string[];
        default?: string;
        updateFunc: (newValue: string) => void;
        currentValueStateValue: string;
        groupName: string;
        groupCssClass: string;
    }[];
}

export const GenericFilterDrawer: React.FC<DrawerProps> = ({
    filterAll,
    onClose,
    isOpen,
    resetFilters,
    applyFilters,
    sections,
}) => {
    return (
        <Drawer placement={'bottom'} onClose={onClose} isOpen={isOpen}>
            <DrawerOverlay />
            <DrawerContent className={`drawer-content drawer-content-${getDeviceType()}`}>
                <DrawerHeader className="filter-drawer-header">
                    <Flex>
                        <Flex className={'filter-drawer-close-button'}>
                            <BsChevronLeft onClick={onClose} />
                        </Flex>
                        <Flex className={'filter-drawer-title'}>
                            <Text>Filters</Text>
                        </Flex>
                        <Flex className="filter-results">
                            <Flex className={'clear-filters'} onClick={resetFilters}>
                                <Button>Reset</Button>
                            </Flex>
                        </Flex>
                    </Flex>
                </DrawerHeader>
                <DrawerBody className="filter-drawer-body">
                    {sections.map((section, index) => {
                        const defaultValue = section.default || filterAll;
                        return (
                            <Box className={`${section.groupCssClass} filter-section`} key={index}>
                                <Text className={'filter-heading'}>{section.name}</Text>
                                <Box className={'radio-filter-container'}>
                                    <RadioFilter
                                        groupName={section.groupName}
                                        options={[
                                            ...section.otherOptions.map((option) => ({
                                                option: option,
                                                className: 'filter-tag',
                                                selectedClassName: 'filter-tag-selected',
                                            })),
                                            {
                                                option: defaultValue,
                                                className: 'filter-tag',
                                                selectedClassName: 'filter-tag-selected',
                                            },
                                        ]}
                                        defaultOption={section.default || filterAll}
                                        onRadioChange={section.updateFunc}
                                        value={section.currentValueStateValue}
                                    />
                                </Box>
                            </Box>
                        );
                    })}
                    <Flex className={'apply-filters'}>
                        <Button className={'apply-button'} onClick={applyFilters}>
                            Apply
                        </Button>
                    </Flex>
                </DrawerBody>
            </DrawerContent>
        </Drawer>
    );
};
